import airbobWordmark from "./airbob-wordmark.png";

export const brandAssets = {
  wordmark: airbobWordmark,
} as const;
